import { useReduxState } from 'hooks';
import { PreEditor } from 'components/editor/inputs';

import type { BlockRaw } from 'shared-types';
import type {
  BlockProps,
  EditorStateProps
} from 'components/editor/blocks/EditorBlock';

type StateProps = Pick<
  EditorStateProps,
  'editorLanguageActive' | 'editorLanguageReference'
>;

const EditorBlockRaw = ({
  data,
  isPreview,
  languageVersion,
  updateData,
  ...stateProps
}: BlockProps<BlockRaw> & StateProps) => {
  const { editorLanguageActive, editorLanguageReference } = stateProps;

  const { messages } = useReduxState();

  const handleChange = (newText: string) => {
    updateData({
      ...data,
      locales: {
        ...data.locales,
        [languageVersion]: {
          ...data.locales[languageVersion],
          translatable: {
            ...data.locales[languageVersion].translatable,
            text: newText
          }
        }
      }
    });
  };

  return (
    <div className="pre">
      <PreEditor
        isPreview={isPreview}
        onChange={handleChange}
        placeholder={messages.commonAddText}
        text={data.locales[languageVersion].translatable.text || ''}
        title={messages.blocksRaw}
        translationReferenceLanguage={
          editorLanguageActive ? editorLanguageReference : null
        }
        translationReferenceText={
          editorLanguageActive
            ? data.locales[editorLanguageReference]?.translatable?.text || ''
            : null
        }
      />

      <div
        className="preview"
        dangerouslySetInnerHTML={{
          __html: data.locales[languageVersion].translatable.text
        }}
      />

      <style jsx>{`
        .preview {
          margin-top: 10px;
        }
      `}</style>
    </div>
  );
};

export default EditorBlockRaw;
